import { Theme } from "@mui/material";
import { colors, hoverColors } from "../../constants/colors";

const styles = {
  'input:-webkit-autofill': {
    
  },
  '& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: colors.black
  },
  '& .MuiFormLabel-root.Mui-focused': {
    color: colors.black
  },
  '& .MuiInputBase-root': {
    backgroundColor: colors.tertiary,
    '&:autofill': {
      backgroundColor: 'red'
    },
    '&.Mui-focused': {
      backgroundColor: '#ebebeb'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.black
    },
    ':hover': {
      backgroundColor: '#eee'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#bbb'
    },
    '&::after': {
      borderBottom: '2px solid ' + colors.primary
    }
  },
  '& .MuiFormLabel-root': {
    color: '#a1a1aa'
  },
  '& .MuiOutlinedInput-input': {
    color: colors.black
  },
  '& .MuiInputBase-input': {
    color: colors.black,
    '&:-webkit-autofill':{
      '-webkit-box-shadow': '0 0 0px 1000px #eee inset',
      '-webkit-text-fill-color': 'black',
      transition: 'background-color 5000s ease-in-out 0s'
    }
  },
}

const inputStyles: any = () => (styles);

export default inputStyles;